module.exports = __webpack_public_path__ + "img/hzgs3.80f7b66b.png";